// extracted by mini-css-extract-plugin
export default {"root":"oXMw7zkn5ju2gllyzPzr","panel":"OSRSIP0oGy7qAyi3E1bo"};